import { ref } from "vue";
import { $http } from "@/plugins/api";
import { createSharedComposable } from "@vueuse/core";
import { getApiClientUrl } from "@/config/runtimeConfig";

type ResolutionHistoryItem = {
  period: string;
  total: number;
};

export const useEmailsChartStore = createSharedComposable(() => {
  const resolutionHistory = ref<ResolutionHistoryItem[]>([]);

  const getResolutionHistory = async ({
    globalOrganisationID,
    params,
  }: {
    globalOrganisationID: string;
    params: Record<string, string>;
  }): Promise<void> => {
    const filterParams = new URLSearchParams(params);
    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/incidents?${filterParams.toString()}`,
    );
    resolutionHistory.value = res.data.data;
  };

  return {
    resolutionHistory,
    getResolutionHistory,
  };
});
